'use strict';

/**
 *
 * @name: matchContributorByType
 *
 */

function MatchContributorByTypeFilter() {

  'ngInject';

  return function(items, contributorTypes) {

    var filtered = [];
    var types = contributorTypes.toString().split(',');

    angular.forEach(items, function(item) {

      angular.forEach(item.roles, function(role) {

        if (types.indexOf(role) > -1) {

          filtered.push(item);
        }
      });
    });

    return filtered;
  };
}

export default MatchContributorByTypeFilter;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-match-contributor-by-type.filter.js